/*
 * Website: https://www.4myth.com
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Copyright © 2016-2022 All rights reserved.
 * MyTh Ahmed Fayez
 */

export default {
  are_you_sure: 'Are you sure?',
  sure_logout: 'Are you sure the account will be logged out?',
  exportAll: 'Are you sure to export all data?',
  confirmDelete: 'Are you sure to delete data?',
  error: 'An error occurred, please try again later.',
  whoops: 'Whoops',
  not_found_message: 'The request not found',
  window_blocked: 'Please make sure to allow pop-ups in your browser to be able to download files. It is recommended to use the Google Chrome browser for all the services and features of the program.',
  404: 'Sorry, the requested page was not found',
  403: 'The requested data cannot be accessed',
  active_user_confirm: 'The account will be activated, do you want to continue?',
  inactive_user_confirm: 'The account will be disabled and the user will not be able to use the account, do you want to continue?',
  max_size: 'Maximum size is {size} MB',
  specifications_update: 'Do you want to replace the item specification stored in the current one?',
  signature_is_empty: 'Please enter signature',
  signature_saved: 'Signature saved successfully',
  import_quotation_items_confirm: 'Do you want to import and delete existing data?'
}
